export enum LocalStorageConstants {
    GAME_PATH = 'game-path'
}